<template>
  <CollapsibleRoot v-model:open="open" :disabled="disabled" asChild>
    <NavDivider
      class="pb-3 last-of-type:pb-0 first-of-type:border-t-0 [&>div]:first-of-type:pt-0 group-data-[collapsed=true]/nav:md:pt-3"
    >
      <div
        v-if="!disabled || label"
        id="heading"
        class="flex items-center pt-3 ltr:pr-2 rtl:pl-2 pb-3 md:pb-2 ltr:pl-1 rtl:pr-1 gap-2 text-primary group-data-[collapsed=true]/nav:md:hidden"
      >
        <span
          v-if="label"
          class="grow text-style-sm md:text-[10px] leading-sm md:leading-xs tracking-[3.36px] md:tracking-[2.4px] font-semibold uppercase"
        >
          {{ label }}
        </span>
        <CollapsibleTrigger v-if="!disabled" asChild>
          <Icon
            class="shrink-0"
            size="md"
            md-size="xs"
            :name="open ? 'chevron-up' : 'chevron-down'"
          />
        </CollapsibleTrigger>
      </div>
      <CollapsibleContent class="flex flex-col gap-1">
        <slot />
      </CollapsibleContent>
    </NavDivider>
  </CollapsibleRoot>
</template>

<script setup>
import { ref } from "vue";
import {
  CollapsibleContent,
  CollapsibleRoot,
  CollapsibleTrigger,
} from "radix-vue";
import { NavDivider } from "@/SharedComponents/Navigation";
import { Icon } from "@/SharedComponents/Icon";

defineProps({
  label: { type: String, required: false },
  disabled: { type: Boolean, required: false },
});

const open = ref(true);
</script>
